import PropTypes from 'prop-types';
import DomainStatusField from './DomainStatusField';
import { CUSTOM_DOMAIN_SSL_FAILED_STATUSES, ROUTES } from '../../utils/constants';

/**
 * @typedef {import('../../types').CurrentSite} CurrentSite
 */

/**
 * Displays the custom domain status section
 * Shows the current custom domain with its activation status
 * @param {object} props - Component props
 * @param {CurrentSite} props.currentSite - The current site data
 * @param {boolean} props.isPending - Whether the domain is pending activation
 */
function CustomDomainStatusSection({ currentSite, isPending }) {
    const isFailed = CUSTOM_DOMAIN_SSL_FAILED_STATUSES.includes(currentSite?.ssl_status);

    return (
        <div className="box-domain box-wrap">
            <div className="box">
                <section className="staticfield">
                    <header>
                        <div className="staticfield-label">Custom Domain</div>
                    </header>
                    {isFailed ? (
                        <p>Your custom domain failed to activate! Check the DNS records.</p>
                    ) : (
                        !isPending && <p>The website address for your publication</p>
                    )}
                    <DomainStatusField
                        status={currentSite?.ssl_status}
                        domain={currentSite?.external_domain}
                        type="custom-domain"
                        linkTo={ROUTES.CUSTOM_DOMAIN}
                    />
                </section>
            </div>
        </div>
    );
}

CustomDomainStatusSection.propTypes = {
    currentSite: PropTypes.shape({
        ssl_status: PropTypes.string,
        external_domain: PropTypes.string,
    }),
    isPending: PropTypes.bool,
};

export default CustomDomainStatusSection;
